<template>
  <div v-if="shouldShowPagination" class="data-grid-pagination" data-testid="pagination-simple">
    <div class="pagination-simple">
      <Button
        v-if="canGoPrevious"
        type="ghost"
        variant="gray"
        icon="general.chevronLeft"
        data-testid="prev-button"
        @click="goToPage(currentPage - 1)"
      />
      <Button
        v-if="canGoNext"
        type="ghost"
        variant="gray"
        icon="general.chevronRight"
        data-testid="next-button"
        @click="goToPage(currentPage + 1)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/storybook';
import { usePagination, type PaginationProps } from '../../composables/usePagination';

interface Props extends PaginationProps {
  totalItems: number;
  perPage: number;
}

interface Emits {
  (e: 'page-change', page: number): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const { canGoPrevious, canGoNext, shouldShowPagination } = usePagination(props);

const goToPage = (page: number) => {
  if (page >= 1 && page <= props.totalPages && page !== props.currentPage) {
    emit('page-change', page);
  }
};
</script>

<style scoped>
.data-grid-pagination {
  @apply flex items-center justify-center w-full py-4;
}

.pagination-simple {
  @apply flex items-center gap-2;
}
</style>